module.exports = __webpack_public_path__ + "static/primer-count-button-1c1034f33e543645609ca2c421da6de1.png";